import React from 'react'
import DashboardLayout from './components/layout/DashboardLayout'

export default function DashboardPage({ user, onLogout }) {
  return (
    <DashboardLayout user={user} onLogout={onLogout}>
      <div className="text-gray-300">
        <h2 className="text-2xl font-bold mb-4">📊 Dashboard Overview</h2>

        <p className="text-gray-400 mb-2">
          Selamat datang, <b>{user?.adminName || user?.email}</b>
        </p>

        <p className="text-gray-500">
          Gunakan menu di sebelah kiri untuk mengelola data pengguna, terapis,
          cleaner, driver, keuangan, dan order.
        </p>

        {/* CARDS */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-6">
          <div className="bg-gray-900 p-5 rounded-xl border border-gray-800 shadow-lg">
            <h3 className="text-lg font-semibold mb-2">👥 Pengguna</h3>
            <p className="text-gray-400 text-sm">
              Kelola akun pengguna aplikasi dengan mudah dari sini.
            </p>
          </div>

          <div className="bg-gray-900 p-5 rounded-xl border border-gray-800 shadow-lg">
            <h3 className="text-lg font-semibold mb-2">💆 Terapis</h3>
            <p className="text-gray-400 text-sm">
              Tambah, edit, atau hapus data terapis dan layanan mereka.
            </p>
          </div>

          <div className="bg-gray-900 p-5 rounded-xl border border-gray-800 shadow-lg">
            <h3 className="text-lg font-semibold mb-2">🧹 Cleaner</h3>
            <p className="text-gray-400 text-sm">
              Kelola data cleaner, layanan aktif, dan foto profil.
            </p>
          </div>
        </div>
      </div>
    </DashboardLayout>
  )
}
